export function computePointsToNextRank(worldRankingData, currentRank, currentPoints) {
  const rank = parseInt(currentRank, 10);
  const points = parseFloat(currentPoints);

  if (Number.isNaN(rank) || Number.isNaN(points) || !worldRankingData?.length) {
    return "N/A";
  }

  if (rank <= 1) {
    return "N/A";
  }

  const teamAbove = worldRankingData.find(
    (item) => parseInt(item.n_WRanking, 10) === rank - 1
  );

  if (!teamAbove) {
    return "N/A";
  }

  const abovePoints = parseFloat(teamAbove.f_WRS);
  if (Number.isNaN(abovePoints)) {
    return "N/A";
  }

  const diff = abovePoints - points;
  return diff > 0 ? diff.toFixed(2) : "0.00";
}

export function computePointsToFirst(worldRankingData, currentRank, currentPoints) {
  const rank = parseInt(currentRank, 10);
  const points = parseFloat(currentPoints);

  if (Number.isNaN(rank) || Number.isNaN(points) || !worldRankingData?.length) {
    return "N/A";
  }

  if (rank === 1) {
    return "0.00";
  }

  const rankOneTeam = worldRankingData.find(
    (item) => parseInt(item.n_WRanking, 10) === 1
  );

  if (!rankOneTeam) {
    return "N/A";
  }

  const topPoints = parseFloat(rankOneTeam.f_WRS);
  if (Number.isNaN(topPoints)) {
    return "N/A";
  }

  const diff = topPoints - points;
  return diff > 0 ? diff.toFixed(2) : "0.00";
}

export function computeCurrentSeasonWinRate(teamStats) {
  if (!teamStats?.length) {
    return "N/A";
  }

  const currentYear = new Date().getFullYear();
  const currentYearStats = teamStats.find((stat) => stat.year === currentYear);

  if (!currentYearStats || !currentYearStats.match_played) {
    return "N/A";
  }

  if (
    currentYearStats.perc_win != null &&
    !Number.isNaN(parseFloat(currentYearStats.perc_win))
  ) {
    return `${currentYearStats.perc_win}%`;
  }

  if (currentYearStats.win != null && currentYearStats.match_played > 0) {
    const rate = Math.round(
      (currentYearStats.win / currentYearStats.match_played) * 100
    );
    return `${rate}%`;
  }

  return "N/A";
}
